<template>
  <div
    class="template-details"
    :class="{'not-modal': isNotModal}"
  >
    <template v-if="canUseNewComunityTemplate"></template>
    <template v-else>
      <aha-ribbon
        v-if="templateData.isAdminPick"
        v-tooltip="staffChoiceIndicatorTooltip"
        class="staff-choice-indicator"
      ></aha-ribbon>
    </template>
    <div class="iframe">
      <div class="staff-choice" v-if="isShowBadge">
        <img src="@/assets/images/community/staff-choice.svg">
      </div>
      <iframe
        id="shared-presentation"
        title="template-preview-iframe"
        :src="`/shared-template/${templateData.shareCode}?hideText=true&hideAccessCode=true`"
        width="610"
        height="344"
      />
    </div>
    <div class="summary">
      <div class="flex flex-row justify-between template-title text-base-90">
        <p class="w-full text-xl font-bold md:w-3/4">
          {{ title }}
        </p>
        <div class="hidden md:block">
          <aha-antd-button
            class="-mt-1 get-template-btn"
            v-aha-emit-action="{ template_id: templateData.id }"
            name="get_template_btn"
            @click="handleChooseTemplate"
            is-loading-inline
            :submitting="isCopyingTemplate"
            :disabled="isCopyingTemplate"
            v-if="!copyType"
          >
            {{ $i18nPresenter.t('Get Template') }}
          </aha-antd-button>
          <aha-antd-button
            class="get-template-btn min-w-36"
            :class="templateData.userId !== currentUser.id ? 'w-full' : 'w-3/5'"
            v-aha-emit-action="{ template_id: templateData.id }"
            name="get_template_btn"
            @click="handleCopySlides"
            is-loading-inline
            :submitting="isCopySlides"
            :disabled="canCopySlides"
            v-if="copyType === 'slides'"
          >
            {{ $i18nPresenter.t('Get Template') }}
          </aha-antd-button>
        </div>
        <aha-dropdown-v2
          :class="['ml-1', copyType ? 'pt-1.5' : 'pt-0.5', 'h-6']"
          v-if="canUseShareableTemplate"
        >
          <aha-dropdown-trigger-v2 name="openTemplateActions" v-aha-emit-action>
            <aha-icon
              class="template__actions"
              name="kebab-menu"
              width="18"
              height="18"
              viewBox="0 0 14 14"
            />
          </aha-dropdown-trigger-v2>
          <aha-dropdown-menu class="template__action--dropdown">
            <aha-dropdown-item-v2
              name="shareTemplateAction"
              v-aha-emit-action
              icon="share-new"
              class="template__action--item"
            >
              <span
                class="d-flex"
                v-clipboard="getShareLink"
                v-clipboard:success="copySharableLink"
              >
                <span>{{ $i18nPresenter.t('Share') }}</span>
              </span>
            </aha-dropdown-item-v2>
          </aha-dropdown-menu>
        </aha-dropdown-v2>
      </div>
      <span class="flex pt-2 pb-2 information">
        <p class="inline-flex items-center mr-4">
          <span class="icon-container">
            <aha-icon
              class="icon-slides"
              name="slides"
              width="10"
              height="10"
              viewBox="0 0 12 12"
              v-tooltip="tooltip_NumberOfSlides"
            />
          </span>
          {{ templateData.slideCount }}
        </p>
        <p class="inline-flex items-center mr-4">
          <span class="icon-container">
            <aha-icon
              class="icon-download-2 text-secondary-50"
              name="download-2"
              viewBox="0 0 14 16"
              width="9"
              v-tooltip="tooltip_NumberOfDownloads"
            />
          </span>
          {{ timesCopied | formatNumber }}
        </p>
        <span class="infomation-author info-author">
          <p
            class="inline-flex items-center mr-4"
            :class="avatarUser ? 'pt-1': ''"
          >
            <span>
              <img
                class="inline-flex mr-2"
                :src="require('@/assets/images/icon/aha-official-avt.svg')"
                v-if="isOfficial"
              >
              <aha-avatar
                v-else
                class="mr-2"
                :name="getAuthorName"
                :image="avatarUser"
                :width="24"
                :height="24"
              />
              <img
                v-if="isOfficial"
                class="inline-flex mr-1"
                :src="require('@/assets/images/icon/author-checked.svg')"
              >
            </span>
            <span
              class="font-bold pt-0.5"
            >
              {{ getAuthorName }}
            </span>
            <span
              v-if="templateData.userId === currentUser.id && !isOfficial"
              class="pt-0.5 ml-1"
            >
              {{ $i18nPresenter.t('(me)') }}
            </span>
          </p>
        </span>
        <InlineCSAT
          v-if="canUseExperimentCSATIntoTemplate"
          :id="`template-inline-csat-${templateData.id}`"
          :tooltip="{
            like: $i18nPresenter.t('I like the template'),
            dislike: $i18nPresenter.t('I don’t like the template'),
          }"
          :data="{
            feature_name: 'Template Detail',
            template_id: templateData.id,
            template_name: templateData.name,
            template_user_id: templateData.userId,
          }"
          :placeholder="$i18nPresenter.t('Let us know how this template can be improved.')"
          class="ml-auto"
          enableFeedback
        />
      </span>
      <div class="items-center w-full mt-2 mb-4 md:hidden">
        <aha-antd-button
          class="get-template-btn min-w-36"
          :class="templateData.userId !== currentUser.id ? 'w-full' : 'w-3/5'"
          @click="handleChooseTemplate"
          is-loading-inline
          :submitting="isCopyingTemplate"
          :disabled="isCopyingTemplate"
          v-if="!copyType"
        >
          {{ $i18nPresenter.t('Get Template') }}
        </aha-antd-button>
        <aha-antd-button
          class="get-template-btn min-w-36"
          :class="templateData.userId !== currentUser.id ? 'w-full' : 'w-3/5'"
          @click="handleCopySlides"
          is-loading-inline
          :submitting="isCopySlides"
          :disabled="canCopySlides"
          v-if="copyType === 'slides'"
        >
          {{ $i18nPresenter.t('Get Template') }}
        </aha-antd-button>
        <div
          class="inline w-1/5 edit-or-unpublish"
          v-if="templateData.userId === currentUser.id"
        >
          <aha-link
            class="mr-2 font-normal underline"
            @click="openEditMetadata"
          >
            {{ $i18nPresenter.t('Edit info') }}
          </aha-link>
          <aha-link
            class="font-normal underline"
            @click="confirmUnpublish"
            :submitting="isPublishing"
          >
            {{ $i18nPresenter.t('Unpublish') }}
          </aha-link>
        </div>
      </div>
      <div
        v-if="description"
        class="overflow-scroll max-h-20 xs:max-h-32 md:max-h-40 md:h-auto md:overflow-auto"
      >
        <span class="description text-base-80">
          {{ description }}
        </span>
      </div>
      <div>
        <div v-if="!isLoadingCategories">
          <p
            v-show="(templateCategories && templateCategories.length >= 1)"
            class="w-full mt-4 font-bold text-md"
          >
            {{ $i18nPresenter.t('Categories') }}
          </p>
          <button
            v-for="item in templateCategories"
            :key="`category-${item.categoryId}`"
            class="category-btn"
            @click="goToCategoryDetail(item.categoryId, item.name)"
          >
            {{ $i18nPresenter.t(item.shortName) }}
          </button>
        </div>
        <div
          v-else
        >
          <Loading class="mx-auto" />
        </div>
      </div>
      <div
        class="absolute flex bottom-4"
        v-if="templateData.userId === currentUser.id"
      >
        <aha-link
          class="hidden font-normal underline md:block"
          @click="openEditMetadata"
        >
          {{ $i18nPresenter.t('Edit info') }}
        </aha-link>
        <span class="mx-1">·</span>
        <aha-link
          class="hidden font-normal underline md:block"
          @click="confirmUnpublish"
          :submitting="isPublishing"
        >
          {{ $i18nPresenter.t('Unpublish') }}
        </aha-link>
      </div>
    </div>

    <modal-confirm-not-publish-template
      v-if="isConfirmNotPublishTemplateModalShowing"
      :presentation="templateData"
      @hide="isConfirmNotPublishTemplateModalShowing = false"
      :unpublish="unpublish"
      :isPublishing="isPublishing"
    />
    <modal-success-publish-template
      v-if="isShowEditMetadata"
      :forceEditMode="forceEditModeSuccessPublishTemplateModal"
      :published="templateData"
      :hide="closeEditMetadata"
      :hideHeader="false"
      :showCustomHeader="false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import EventBus from '@/eventBus'
import Utils from '@/util'
import Constants from '@/constant'
import CommunityApi from '@/api/community'
import ModalConfirmNotPublishTemplate from '@/components-v2/modals/ConfirmNotPublishTemplate.vue'
import ModalSuccessPublishTemplate from '@/components-v2/modals/SuccessPublishPresentations.vue'
import AhaRibbon from '@/components-v2/common/ribbon/Ribbon.vue'
import Loading from '@/components/Loading'
import CategoryApi from '@/api/category'
import { ROUTE_NAMES } from '@/constant/routes'
import Config from '@/config'
import InlineCSAT from '@/components-v2/common/csat/InlineCSAT.vue'

export default {
  components: {
    ModalConfirmNotPublishTemplate,
    ModalSuccessPublishTemplate,
    Loading,
    AhaRibbon,
    InlineCSAT,
  },
  props: {
    templateData: {
      type: Object,
      required: true,
    },
    templateLocation: {
      type: String,
      default: null,
    },
    copyType: {
      type: String,
      default: '',
    },
    isNotModal: {
      type: Boolean,
      default: false,
    },
    onCategoryChange: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data: () => ({
    id: 'template-preview',
    targetX: 0,
    targetY: 0,
    isShowShareModal: false,
    isConfirmNotPublishTemplateModalShowing: false,
    isPublishing: false,
    isShowEditMetadata: false,
    forceEditModeSuccessPublishTemplateModal: false,
    latestClickedTemplate: {},
    publishedTemplate: {},
    allCategories: [],
    templateCategories: [],
    isLoadingCategories: false,
    isTemplateCopyClicked: false,
    isCopySlides: false,
  }),
  // Luu y: khong duoc dung this.$i18nPresenter.t trong ham data phia tren, DucTrinh viet sang dang arrow function khong co tu khoa this :|
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      canEditPresentation: (state) => state.canEditPresentation,
    }),
    ...mapGetters('presentationTemplates', [
      'copyingTemplateId',
    ]),
    ...mapGetters('featureToggles', [
      'canUseNewComunityTemplate',
      'canUseShareableTemplate',
      'canUseExperimentCSATIntoTemplate',
    ]),
    titleShareTemplate() {
      return this.$i18nPresenter.t('Share Template')
    },
    staffChoiceIndicatorTooltip() {
      return {
        placement: 'right',
        content: this.$i18nPresenter.t('Staff Choice'),
      }
    },
    tooltip_NumberOfSlides() {
      return this.$i18nPresenter.t('Number of slides')
    },
    tooltip_NumberOfDownloads() {
      return this.$i18nPresenter.t('Number of downloads')
    },
    getPresenterLink() {
      return window.location.origin
    },
    title() {
      if (this.publishedTemplate && this.publishedTemplate.name) {
        return this.publishedTemplate.name.trim()
      }
      return this.templateData.name.trim()
    },
    timesCopied() {
      return this.templateData.copyCount
    },
    getAuthorName() {
      const { firstName, lastName } = this.templateData.User
      if (this.templateData.User && this.templateData.User.type === 'official') return 'AhaSlides Official'
      return `${firstName} ${lastName}`
    },
    description() {
      if (this.publishedTemplate && this.publishedTemplate.description) {
        return this.publishedTemplate.description.trim()
      }
      if (this.templateData && this.templateData.description) {
        return this.templateData.description.trim()
      }
      return ''
    },
    isOfficial() {
      if (this.templateData.User) {
        return this.templateData.User.type === 'official'
      }
      return false
    },
    avatarUser() {
      if (this.templateData && this.templateData.User) {
        return this.templateData.User.avatar
      }
      return ''
    },
    isCopyingTemplate() {
      if (this.disableGetTemplate) return true
      if (this.isTemplateCopyClicked) return this.$route.name !== 'PresentationDetail'
      if (this.copyingTemplateId) {
        if (this.$route.name !== 'PresentationDetail') return true
        return false
      }
      return false
    },
    disableGetTemplate() {
      return this.$route.name === ROUTE_NAMES.PRESENTATION_DETAIL && !this.canEditPresentation
    },
    canCopySlides() {
      return this.disableGetTemplate || this.isCopySlides
    },
    isShowBadge() {
      return this.canUseNewComunityTemplate && this.templateData.isAdminPick
    },
  },
  async created() {
    await this.categoriesProcessing()
  },
  mounted() {
    EventBus.$on(Constants.Events.EVENT_CHANGE_SLIDE, (slide) => {
      this.postMessage(slide)
    })
    this.resizeIframe()
    EventBus.$on('update-template-detail-after-published', (template) => {
      this.publishedTemplate = template
      this.updateCurrentCategories(template.categoryIds)
    })
  },
  destroyed() {
    EventBus.$off(Constants.Events.EVENT_CHANGE_SLIDE)
    EventBus.$off('update-template-detail-after-published')
  },
  methods: {
    ...mapActions('presentationTemplates', ['copyFromTemplateAction', 'getNewlyAddedAction', 'copySlidesAction']),
    ...mapActions(['setCurrentUserHasCreatedPresentationAction']),
    getShareLink() {
      const { slugifiedName, id } = this.templateData
      return `${Config.ssrDomain}/templates/p/${slugifiedName}-${id}/`
    },
    resizeIframe() {
      const iframe = document.getElementById('shared-presentation')
      const DEFAULT_WIDTH = 610
      const DEFAULT_HEIGHT = 344
      const currentWidth = iframe.offsetWidth
      const currentHeight = (currentWidth / DEFAULT_WIDTH) * DEFAULT_HEIGHT
      iframe.height = currentHeight
    },
    copySharableLink() {
      Utils.showToastSuccess(this.$i18nPresenter.t('Link copied to clipboard'))
    },
    postMessage(slide) {
      const iframe = document.getElementById('shared-presentation').contentWindow
      iframe.postMessage({
        type: Constants.Events.EVENT_CHANGE_SLIDE,
        slide,
      }, '*')
    },
    handleChooseTemplate() {
      this.isTemplateCopyClicked = true
      this.copyFromTemplateAction({
        template: this.templateData,
        callback: this.handleCopyTemplateSuccess,
      })
    },
    handleCopyTemplateSuccess(presentation) {
      const newPresentationId = presentation.id
      const params = { id: newPresentationId }
      this.$router.push({ name: 'PresentationDetail', params })
      this.setCurrentUserHasCreatedPresentationAction()
    },
    async confirmUnpublish() {
      this.isConfirmNotPublishTemplateModalShowing = true
      Utils.mixpanelTracking('Template Library > Template preview', 'Open Unpublish modal', '', this.templateData.id)
    },
    async unpublish() {
      this.isPublishing = true
      try {
        await CommunityApi.unpublishPresentation({
          presentationIds: [this.templateData.id],
        })
        EventBus.$emit('hide-modal-preview-template')
        EventBus.$emit('update-template-category') // Update metadata: Template Category Detail
        if (this.$route.name !== 'TemplateCategory') {
          this.$router.push('/apps/template-library')
        }
        await this.getNewlyAddedAction()
        Utils.showToastSuccess(this.$i18nPresenter.t('Your presentation has been unpublished'))
        return true
      } catch (error) {
        Sentry.captureException(error)
        // wait till ES finishes syncing to all nodes in cluster
        Utils.showToastError(this.$i18nPresenter.t('You have performed the actions too quickly. Please try again in a few minutes.'))
        return false
      } finally {
        this.isPublishing = false
        Utils.mixpanelTracking('Template Library > Template preview', 'Unpublish successfully', '', this.templateData.id)
      }
    },
    openEditMetadata() {
      this.$store.commit('updatePresentation', this.templateData)
      this.isShowEditMetadata = true
      this.forceEditModeSuccessPublishTemplateModal = true
      const el = document.getElementById('zsiq_float')
      if (el) {
        el.style.display = 'none'
      }
      Utils.mixpanelTracking('Template Library > Preview', 'Publish to Template Library > Edit Info')
    },
    closeEditMetadata() {
      this.isShowEditMetadata = false
      this.forceEditModeSuccessPublishTemplateModal = false
      const el = document.getElementById('zsiq_float')
      if (el) {
        el.style.display = 'block'
      }
    },
    filterCategories() {
      if (this.templateData.PresentationsCategories.length > 0) {
        const templateCategoryIds = this.templateData.PresentationsCategories.map((item) => {
          return item.categoryId
        })
        this.templateCategories = this.allCategories.filter((item) => {
          return templateCategoryIds.includes(item.categoryId)
        })
      } else {
        this.templateCategories = []
      }
    },
    async categoriesProcessing() {
      this.isLoadingCategories = true
      const res = await CategoryApi.getAllCategories()
      this.allCategories = res.data.map((item) => {
        return {
          categoryId: item.id,
          name: item.name,
          shortName: item.shortName,
        }
      })
      this.filterCategories()
      this.isLoadingCategories = false
    },
    updateCurrentCategories(templateCategoryIds) {
      this.templateCategories = this.allCategories.filter((item) => {
        return templateCategoryIds.includes(item.categoryId)
      })
    },
    goToCategoryDetail(id, name) {
      EventBus.$emit('hide-modal-preview-template')

      if (this.onCategoryChange) {
        this.onCategoryChange({
          id,
          label: name,
        })
      } else {
        this.handleDefaultCategoryChange(id)
      }

      if (id) {
        Utils.mixpanelTracking('Template Preview > Open Category', 'Open Category', '', id)
      }
    },
    handleDefaultCategoryChange(id) {
      this.$router.push({ name: ROUTE_NAMES.TEMPLATE_LIBRARY, query: { category: id } })
    },

    async handleCopySlides() {
      if (this.isCopySlides) return
      this.isCopySlides = true
      await this.copySlidesAction(this.templateData.id)
      this.isCopySlides = false
    },
  },
}
</script>

<style lang="scss" scoped>
.template-details {
  @apply flex flex-col;
  position: relative;
  padding: 40px 20px;
  width: 650px;
  &.not-modal {
    background-color: #fff;
  }

  @media screen and (max-width: 520px) {
    max-width: 100%;
  }
  @media screen and (max-width: 1000px) {
    width: 500px;
  }
  @media screen and (max-width: 767px) {
    padding: 16px;
    padding-top: 40px;
    width: 100%;
  }
  .staff-choice-indicator {
    top: 0;
    left: 2rem;
    position: absolute;
    cursor: pointer;
  }
  .description {
    white-space: pre-line;
  }
  .information {
    flex-flow: row wrap;
  }
  .infomation-author {
    @media screen and (max-width: 480px) {
      margin-top: 0.25rem;
    }
  }

  iframe {
    width: 100%;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    @apply mb-4;
  }

  .icon-container {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    background: #EFF1F7;
    position: relative;
    margin-right: 3px;

    .icon-download-2 {
      position: absolute;
      top: 1px;
      right: 5px
    }

    .icon-slides {
      right: 5px;
      top: 5px;
      position: absolute;
    }
  }

  .open-new-window {
    @apply text-base-50 absolute;
    top: -3px;
  }
  .aha-avatar {
    display: flex;
  }
  .edit-or-unpublish {
    @apply ml-4;
    @media (max-width: 390px) {
      @apply ml-2;
    }
  }
  .category-btn {
    border-radius: 20px;
    border: 1px solid #D3D7E1;
    padding: 6px 12px;
    margin: 4px 2px;
    height: 32px;
    color: #525F7F;
    cursor: pointer;
    letter-spacing: 0px;
    transition: 0.15s linear;
    font-Weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
    transition: all 0.3s ease;

    &:hover {
      border-color: #348EF6;
      color: #348EF6;
    }
  }
  .staff-choice {
    position: absolute;
    top: 41px;
    left: 21px;
    z-index: 1;
  }
}

@media screen and (max-width: 768px)  {
  .template-details .staff-choice {
    left: 17px;
  }
}

.template__action--dropdown {
  //dropdown has inline style for width: 100%, need important to override that
  width: max-content !important;
  left: unset;
  right: 0;
}

.template__action--item {
  display: flex;
  max-width: unset;
  min-width: unset;
  width: max-content;
  align-items: center;
}

.template__actions {
  cursor: pointer;
}

</style>
